module.exports = __webpack_public_path__ + "static/feature-2-6b821be0a44f359600c865160ae3446e.svg";